import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import "./mobileuser.css";
import { configuration } from "../../../appConfig";
import Spinner from "../../../spinner/index";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

class EmailAuthorized extends Component {
  constructor(props) {
    super(props);
    this.state = {
      words: {},
      lang: "de",
      emailArr: "",
      scanEmailArr: "",
      ccEmailArr: "",
      partnerIDArr: "",
      authorizeName: "",
      emailArrError: "",
      scanEmailArrError: "",
      partnerIDError: "",
      ccEmailArrError: "",
      parentPartnerIdArr: [],
      parentPartnerId: "",
      tableData: [],
      scanEmailTableData: [],
      authorizeNameList: [],
      selectedRows: [],
      isModalOpen: false,
      isScanEmailModalOpen: false,
      ischecked: false,
      selectedEmail: "",
      selectedCcEmail: "",
      editEmailArrError: "",
      editCcEmailArrError: "",
      isOpenDeleteEmailModal: false,
      isOpenDeleteScanEmailModal: false,
      openAddEmailModal: false,
      openAddScanEmailModal: false,
      openAddNameModal: false,
      openEditNameModal: false,
      emailLoaging: false,
      scanEmailLoaging: false,
      authNameLoading: false,
    };
  }
  async componentDidMount() {
    this.getLang();
    this.getParentPartnerId();
    this.getAuthorizeName();
    this.getEmailData();
    this.getScanEmailData();
  }

  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  getParentPartnerId = (e) => {
    let url = `${configuration.getTemplates}` + "?type=" + "partnerIds";
    axios
      .get(url)
      .then((res) => {
        if (res) {
          this.setState({
            parentPartnerIdArr: res.data.data,
          });
        }
      })
      .catch((err) => {});
  };

  handleInputChange = (e, field) => {
    this.setState({ [field]: e.target.value });
  };

  getEmailData = () => {
    this.setState({emailLoaging: true});
    const partnerID = localStorage.getItem("partnerId");
    let url = `${configuration.getEmailData}` + "?partnerId=" + `${partnerID}`;
    axios
      .get(url)
      .then((res) => {
        if (res) {
          this.setState({
            tableData: res.data.data,
            emailLoaging: false
          });
        } else {
          this.setState({emailLoaging: false});
        }
      })
      .catch((err) => {
        this.setState({emailLoaging: false});
      });
  };
  getAuthorizeName = () => {
    this.setState({authNameLoading: true});
    const partnerID = localStorage.getItem("partnerId");
    let url =
      `${configuration.getAuthorizeName}` + "?partnerId=" + `${partnerID}`;
    axios
      .get(url)
      .then((res) => {
        if (res) {
          this.setState({
            authorizeNameList: res.data.data,
            authNameLoading: false
          });
        } else { this.setState({authNameLoading: false});
        }
      })
      .catch((err) => {
        this.setState({authNameLoading: false});
      });
  };

  getScanEmailData = () => {
    this.setState({scanEmailLoaging: true});
    const partnerID = localStorage.getItem("partnerId");
    let url = `${configuration.getScanEmailData}` + "?partnerId=" + `${partnerID}`;

    axios
      .get(url)
      .then((res) => {
        if (res) {
          this.setState({
            scanEmailTableData: res.data.data,
            scanEmailLoaging: false
          });
        } else {
          this.setState({scanEmailLoaging: false});
        }
      })
      .catch((err) => {
        this.setState({scanEmailLoaging: false});
      });
  };

  addEmails = (e) => {
    const { emailArr } = this.state;

    const payload = {
      partnerId: localStorage.getItem("partnerId"),
      email: emailArr ? emailArr : "",
    };

    let url = `${configuration.add_email}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.setState({
            partnerIDArr: "",
            emailArr: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
          this.getEmailData();
          this.toggleModal("openAddEmailModal");
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error adding emails:", err);
      });
  };
  addScanEmails = (e) => {
    const { scanEmailArr } = this.state;

    const payload = {
      partnerId: localStorage.getItem("partnerId"),
      email: scanEmailArr ? scanEmailArr : "",
    };

    let url = `${configuration.add_ScanEmail}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.setState({
            partnerIDArr: "",
            scanEmailArr: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
          this.getScanEmailData();
          this.toggleModal("openAddScanEmailModal");
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error adding emails:", err);
      });
  };

  deleteEmail = (id) => {
    const payload = {
      e_id: id,
    };

    let url = `${configuration.deleteEmail}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.getEmailData();

          this.setState({
            isOpenDeleteEmailModal: false,
            partnerIDArr: "",
            emailArr: "",
            ccEmailArr: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error deleting email:", err);
      });
  };
  
  deleteScanEmail = (id) => {
    const payload = {
      e_id: id,
    };

    let url = `${configuration.deleteScanEmail}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.getScanEmailData();

          this.setState({
            isOpenDeleteScanEmailModal: false,
            partnerIDArr: "",
            scanEmailArr: "",
            ccEmailArr: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error deleting email:", err);
      });
  };

  deleteName = (id) => {
    const payload = {
      a_id: id,
    };

    let url = `${configuration.deleteAuthorizeName}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.getAuthorizeName();
          this.setState({
            authNameId: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error deleting email:", err);
      });
  };

  addAuthorizeName = () => {
    const { authorizeName } = this.state;

    const payload = {
      partnerId: localStorage.getItem("partnerId"),
      name: authorizeName ? authorizeName : "",
    };

    let url = `${configuration.addAuthorizeName}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.setState({
            authorizeName: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
          this.getAuthorizeName();
          this.toggleModal("openAddNameModal");
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error adding Name:", err);
      });
  };

  editEmail = () => {
    const { selectedEmail, emailAddressId } = this.state;

    const payload = {
      partnerId: localStorage.getItem("partnerId"),
      email: selectedEmail,
      e_id: emailAddressId,
    };

    let url = `${configuration.editEmail}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.getEmailData();
          this.toggleModal("isModalOpen");
          this.setState({
            partnerIDArr: "",
            emailArr: "",
            ccEmailArr: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error editing email:", err);
      });
  };

  editScanEmail = () => {
    const { selectedEmail, emailAddressId } = this.state;

    const payload = {
      partnerId: localStorage.getItem("partnerId"),
      email: selectedEmail,
      e_id: emailAddressId,
    };

    let url = `${configuration.editScanEmail}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.getScanEmailData();
          this.toggleModal("isScanEmailModalOpen");
          this.setState({
            partnerIDArr: "",
            scanEmailArr: "",
            ccEmailArr: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error editing email:", err);
      });
  };

  editName = () => {
    const { selectedName, authNameId } = this.state;

    const payload = {
      partnerId: localStorage.getItem("partnerId"),
      name: selectedName,
      a_id: authNameId,
    };

    let url = `${configuration.editAuthorizeName}`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status == true) {
          this.getAuthorizeName();
          this.toggleModal("openEditNameModal");
          this.setState({
            authNameId: "",
            editName: "",
          });
          Toast.fire({
            type: "success",
            title: res.data.message,
          });
        } else {
          Toast.fire({
            type: "error",
            title: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error("Error editing email:", err);
      });
  };

  toggleModal = (modalStateKey, value, id) => {
    this.setState((prevState) => ({
      [modalStateKey]: !prevState[modalStateKey],
      selectedEmail: value,
      emailAddressId: id,
    }));
  };
  nameToggleModal = (modalStateKey, value, id) => {
    this.setState((prevState) => ({
      [modalStateKey]: !prevState[modalStateKey],
      selectedName: value,
      authNameId: id,
    }));
  };

  handleModalInputChange = (e, field) => {
    this.setState({ [field]: e.target.value });
  };

  handleModalSubmit = () => {
    const { selectedEmail } = this.state;
    let editEmailArrError = "";

    if (!this.validateEmail(selectedEmail)) {
      editEmailArrError = "Invalid Emails address detected!";
    }

    if (editEmailArrError) {
      this.setState({ editEmailArrError });
      setTimeout(() => {
        this.setState({ editEmailArrError: "" });
      }, 3000);
    } else {
      this.editEmail();
    }
  };

  handleModalScanEmailSubmit = () => {
    const { selectedEmail } = this.state;
    let editEmailArrError = "";

    if (!this.validateEmail(selectedEmail)) {
      editEmailArrError = "Invalid Emails address detected!";
    }

    if (editEmailArrError) {
      this.setState({ editEmailArrError });
      setTimeout(() => {
        this.setState({ editEmailArrError: "" });
      }, 3000);
    } else {
      this.editScanEmail();
    }
  };
  handleEditNameModal = () => {
    const { selectedName } = this.state;
    let editNameError = "";

    if (selectedName.trim() == "") {
      editNameError = "Invalid Emails address detected!";
    }

    if (editNameError) {
      this.setState({ editNameError });
      setTimeout(() => {
        this.setState({ editNameError: "" });
      }, 3000);
    } else {
      this.editName();
    }
  };
  handleAddAuthorizeName = () => {
    const { authorizeName } = this.state;
    let addNameError = "";

    if (authorizeName.trim() == "") {
      addNameError = "Invalid Authorize Name detected!";
    }

    if (addNameError) {
      this.setState({ addNameError });
      setTimeout(() => {
        this.setState({ addNameError: "" });
      }, 3000);
    } else {
      this.addAuthorizeName();
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(String(email).toLowerCase());
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { emailArr } = this.state;
    let emailArrError = "";

    if (!emailArr && !this.validateEmail(emailArr)) {
      emailArrError = "Invalid email address detected!";
    }

    if (emailArrError) {
      this.setState({ emailArrError });
      setTimeout(() => {
        this.setState({ emailArrError: "" });
      }, 3000);
    } else {
      // Call the addEmails function to submit the data
      this.addEmails();
    }
  };

  handleScanEmailSubmit = (e) => {
    e.preventDefault();
    const { scanEmailArr } = this.state;
    let scanEmailArrError = "";

    if (!scanEmailArr && !this.validateEmail(scanEmailArr)) {
      scanEmailArrError = "Invalid email address detected!";
    }

    if (scanEmailArrError) {
      this.setState({ scanEmailArrError });
      setTimeout(() => {
        this.setState({ scanEmailArrError: "" });
      }, 3000);
    } else {
      // Call the addEmails function to submit the data
      this.addScanEmails();
    }
  };

  handleCheckboxChange = (e, row, index) => {
    const { name, checked } = e.target;
    let updatedRow = { ...row, [name]: checked ? 1 : 0 };

    if (name === "is_to" && !checked) {
      updatedRow["is_to_default"] = 0;
    }
    if (name === "is_cc" && !checked) {
      updatedRow["is_cc_default"] = 0;
    }

    this.setState({ selectedRows: updatedRow }, () => {
      this.handleChangeEmailStatus();
    });
  };
  handleCheckboxChange = (e, row, index) => {
    const { name, checked } = e.target;
    let updatedRow = { ...row, [name]: checked ? 1 : 0 };

    if (name === "is_to" && !checked) {
      updatedRow["is_to_default"] = 0;
    }
    if (name === "is_cc" && !checked) {
      updatedRow["is_cc_default"] = 0;
    }

    this.setState({ selectedRows: updatedRow }, () => {
      this.handleChangeEmailStatus();
    });
  };

  handleScanEmailCheckboxChange = (e, row, index) => {
    const { name, checked } = e.target;
    let updatedRow = { ...row, [name]: checked ? 1 : 0 };
    console.log('updatedRow :>> ', updatedRow);

    this.setState({ selectedRows: updatedRow }, () => {
      this.handleChangeScanEmailStatus();
    });
  };

  handleChangeNameStatus = (id) => {
    const url = `${configuration.statusAuthorizeName}?a_id=${id}`;

    // Assuming you are using Axios to send data
    axios
      .post(url)
      .then((response) => {
        console.log(response);
        
        if (response.data.status == true) {
          Toast.fire({
            type: "success",
            title: "Name Status Update successfully",
          });
          this.getAuthorizeName();
        }
      })
      .catch((err) => {
        console.error("Error updating Name status:", err);
      });
  };

  handleChangeEmailStatus = () => {
    const { selectedRows } = this.state;
    const url = `${configuration.changeStatus}?e_id=${selectedRows.id}&is_to=${selectedRows.is_to}&is_to_default=${selectedRows.is_to_default}&is_cc=${selectedRows.is_cc}&is_cc_default=${selectedRows.is_cc_default}`;

    // Assuming you are using Axios to send data
    axios
      .post(url)
      .then((response) => {
        if (response.data.status == true) {
          Toast.fire({
            type: "success",
            title: "Email Status Update successfully",
          });
          this.getEmailData();
        }
      })
      .catch((err) => {
        console.error("Error updating email status:", err);
      });
  };

  handleChangeScanEmailStatus = () => {
    const { selectedRows } = this.state;
    const url = `${configuration.changeStatusScanEmail}?e_id=${selectedRows.id}&is_to=${selectedRows.is_to != '' ? selectedRows.is_to : 0}&is_cc=${selectedRows.is_cc != '' ? selectedRows.is_cc : 0}`;

    // Assuming you are using Axios to send data
    axios
      .post(url)
      .then((response) => {
        if (response.data.status == true) {
          Toast.fire({
            type: "success",
            title: "Email Status Update successfully",
          });
          this.getScanEmailData();
        }
      })
      .catch((err) => {
        console.error("Error updating email status:", err);
      });
  };

  render() {
    const {
      emailArr,
      scanEmailArr,
      emailArrError,
      scanEmailArrError,
      tableData,
      scanEmailTableData,
      isModalOpen,
      isScanEmailModalOpen,
      selectedEmail,
      editEmailArrError,
      openAddEmailModal,
      openAddScanEmailModal,
      authorizeName,
      openAddNameModal,
      addNameError,
      authorizeNameList,
      openEditNameModal,
      editNameError,
      selectedName,
      emailLoaging,
      scanEmailLoaging,
      authNameLoading,
    } = this.state;

    return (
      <div className="mobile_user_main_wrapper">
        <Row className="justify-content-center">
          <Col xl={10} lg={11} md={12} sm={12}>
            <ul className="nav nav-pills" id="myTab" role="tablist">
              <li className="nav-item active" role="presentation">
                <button
                  className="nav-link active"
                  id="email-authorise-list-details-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#email-authorise-list-details"
                  type="button"
                  role="tab"
                  aria-controls="email-authorise-list-details"
                  aria-selected="true"
                  onClick={this.getEmailData}
                >
                  {this.lang("EmailList")}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="add-authorizer-name-details-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#add-authorizer-name-details"
                  type="button"
                  role="tab"
                  aria-controls="add-authorizer-name-details"
                  aria-selected="false"
                  onClick={this.getAuthorizeName}
                >
                  {this.lang("Authorizer name")}
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="scan-email-list-details-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#scan-email-list-details"
                  type="button"
                  role="tab"
                  aria-controls="scan-email-list-details"
                  aria-selected="true"
                  onClick={this.getScanEmailData}
                >
                  {this.lang("Scan Email")}
                </button>
              </li>
            </ul>
            <div className="tab-content" id="user-profile-wrapperContent">
              {/* Email Authorise List Details Tab Content */}
              <div
                className="tab-pane fade active show"
                id="email-authorise-list-details"
                role="tabpanel"
                aria-labelledby="email-authorise-list-details-tab"
              >
                <Card className="mobile_user_card">
                  <CardBody>
                    <div className="row">
                      <div className="col-lg-12">
                        <button
                          type="submit"
                          className="btn pull-right theme_button"
                          onClick={() => this.toggleModal("openAddEmailModal")}
                        >
                          {this.lang("AddEmail")}
                        </button>
                      </div>
                      <div className="col-lg-12">
                        <div className="table-responsive mt-2">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{this.lang("Sr. No")}</th>
                                <th>{this.lang("Email")}</th>
                                <th className="default_col text-center">
                                  {this.lang("To")}
                                </th>
                                <th className="default_col text-center">
                                  {this.lang("To Default")}
                                </th>
                                <th className="default_col text-center">
                                  {this.lang("CC")}
                                </th>
                                <th className="default_col text-center">
                                  {this.lang("CC Default")}
                                </th>
                                <th className="default_col text-center">
                                  {this.lang("Status")}
                                </th>
                                <th className="text-center">
                                  {this.lang("Actions")}
                                </th>
                              </tr>
                            </thead>
                            {emailLoaging &&<tr><td colSpan={"8"}><Spinner /></td></tr> }
                            <tbody>
                              {!emailLoaging && tableData &&
                                Array.isArray(tableData) &&
                                tableData.length > 0 ?
                                tableData.map((row, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{row.email_id}</td>
                                      <td className="default_col text-center">
                                        <input
                                          type="checkbox"
                                          name="is_to"
                                          checked={row.is_to == 1}
                                          disabled={row.is_cc == 1}
                                          id={`${i}toEmail`}
                                          onChange={(e) =>
                                            this.handleCheckboxChange(e, row, i)
                                          }
                                        />
                                      </td>
                                      <td className="default_col text-center">
                                        <input
                                          type="checkbox"
                                          name="is_to_default"
                                          checked={row.is_to_default == 1}
                                          id={`${i}toDefaultEmail`}
                                          disabled={row.is_to == 0}
                                          onChange={(e) =>
                                            this.handleCheckboxChange(e, row, i)
                                          }
                                        />
                                      </td>
                                      <td className="default_col text-center">
                                        <input
                                          type="checkbox"
                                          name="is_cc"
                                          checked={row.is_cc == 1}
                                          id={`${i}ccEmail`}
                                          disabled={row.is_to == 1}
                                          onChange={(e) =>
                                            this.handleCheckboxChange(e, row, i)
                                          }
                                        />
                                      </td>
                                      <td className="default_col text-center">
                                        <input
                                          type="checkbox"
                                          name="is_cc_default"
                                          checked={row.is_cc_default == 1}
                                          id={`${i}ccDefaultEmail`}
                                          disabled={row.is_cc == 0}
                                          onChange={(e) =>
                                            this.handleCheckboxChange(e, row, i)
                                          }
                                        />
                                      </td>
                                      {row.is_active == 1 ? (
                                        <td className="order-status-row text-center active">
                                          Active
                                        </td>
                                      ) : (
                                        <td className="order-status-row text-center deactive">
                                          Deactive
                                        </td>
                                      )}
                                      <td className="text-center">
                                        <button
                                          className="edit_btn"
                                          onClick={() =>
                                            this.toggleModal(
                                              "isModalOpen",
                                              row.email_id,
                                              row.id
                                            )
                                          }
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                        <button
                                          className="edit_btn"
                                          onClick={() =>
                                            this.toggleModal(
                                              "isOpenDeleteEmailModal",
                                              row.email_id,
                                              row.id
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                }) : !emailLoaging && <tr><td colSpan="8" className="text-center">No record Found</td></tr>}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
              {/* Add Authorizer Name Details Tab Content */}
              <div
                className="tab-pane fade"
                id="add-authorizer-name-details"
                role="tabpanel"
                aria-labelledby="add-authorizer-name-details-tab"
              >
                <Card className="mobile_user_card">
                  <CardBody>
                    <div className="row">
                      <div className="col-lg-12">
                        <button
                          type="submit"
                          className="btn pull-right theme_button"
                          onClick={() => this.toggleModal("openAddNameModal")}
                        >
                          {this.lang("Add Name")}
                        </button>
                      </div>
                      <div className="col-lg-12">
                        <div className="table-responsive mt-2">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{this.lang("Sr. No")}</th>
                                <th>{this.lang("Name")}</th>
                                <th className="default_col text-center">
                                  {this.lang("Default")}
                                </th>
                                <th className="default_col text-center">
                                  {this.lang("Status")}
                                </th>
                                <th className="text-center">
                                  {this.lang("Actions")}
                                </th>
                              </tr>
                            </thead>
                            {authNameLoading &&<tr><td colSpan={"5"}><Spinner /></td></tr> }
                            <tbody>
                              {!authNameLoading && authorizeNameList &&
                                Array.isArray(authorizeNameList) &&
                                authorizeNameList.length > 0 ?
                                authorizeNameList.map((name, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{name.name}</td>
                                      <td className="default_col text-center">
                                        <input
                                          type="checkbox"
                                          checked={name.is_default == 1}
                                          onChange={() =>
                                            this.handleChangeNameStatus(name.id)
                                          }
                                        />
                                      </td>
                                      {name.is_default == 1 ? (
                                        <td className="order-status-row text-center active">
                                          Active
                                        </td>
                                      ) : (
                                        <td className="order-status-row text-center deactive">
                                          Deactive
                                        </td>
                                      )}
                                      <td className="text-center">
                                        <button
                                          className="edit_btn"
                                          onClick={() =>
                                            this.nameToggleModal(
                                              "openEditNameModal",
                                              name.name,
                                              name.id
                                            )
                                          }
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                        <button
                                          className="edit_btn"
                                          onClick={() =>
                                            this.nameToggleModal(
                                              "isOpenDeleteNameModal",
                                              name.name,
                                              name.id
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                }) : !authNameLoading && <tr><td colSpan="5" className="text-center">No record Found</td></tr>}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
              {/* Scan Email Details Tab Content */}
              <div
                className="tab-pane fade show"
                id="scan-email-list-details"
                role="tabpanel"
                aria-labelledby="scan-email-list-details-tab"
              >
                <Card className="mobile_user_card">
                  <CardBody>
                    <div className="row">
                      <div className="col-lg-12">
                        <button
                          type="submit"
                          className="btn pull-right theme_button"
                          onClick={() => this.toggleModal("openAddScanEmailModal")}
                        >
                          {this.lang("Add Scan Email")}
                        </button>
                      </div>
                      <div className="col-lg-12">
                        <div className="table-responsive mt-2">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{this.lang("Sr. No")}</th>
                                <th>{this.lang("Email")}</th>
                                <th className="default_col text-center">
                                  {this.lang("To")}
                                </th>
                                <th className="default_col text-center">
                                  {this.lang("CC")}
                                </th>
                                <th className="default_col text-center">
                                  {this.lang("Status")}
                                </th>
                                <th className="text-center">
                                  {this.lang("Actions")}
                                </th>
                              </tr>
                            </thead>
                            {scanEmailLoaging &&<tr><td colSpan={"8"}><Spinner /></td></tr> }
                            <tbody>
                              {!scanEmailLoaging && scanEmailTableData &&
                                Array.isArray(scanEmailTableData) &&
                                scanEmailTableData.length > 0 ?
                                scanEmailTableData.map((row, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{row.email_id}</td>
                                      <td className="default_col text-center">
                                        <input
                                          type="checkbox"
                                          name="is_to"
                                          checked={row.is_to == 1}
                                          disabled={row.is_cc == 1}
                                          id={`${i}toEmail`}
                                          onChange={(e) =>
                                            this.handleScanEmailCheckboxChange(e, row, i)
                                          }
                                        />
                                      </td>
                                      <td className="default_col text-center">
                                        <input
                                          type="checkbox"
                                          name="is_cc"
                                          checked={row.is_cc == 1}
                                          id={`${i}ccEmail`}
                                          disabled={row.is_to == 1}
                                          onChange={(e) =>
                                            this.handleScanEmailCheckboxChange(e, row, i)
                                          }
                                        />
                                      </td>
                                      {row.is_active == 1 ? (
                                        <td className="order-status-row text-center active">
                                          Active
                                        </td>
                                      ) : (
                                        <td className="order-status-row text-center deactive">
                                          Deactive
                                        </td>
                                      )}
                                      <td className="text-center">
                                        <button
                                          className="edit_btn"
                                          onClick={() =>
                                            this.toggleModal(
                                              "isScanEmailModalOpen",
                                              row.email_id,
                                              row.id
                                            )
                                          }
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </button>
                                        <button
                                          className="edit_btn"
                                          onClick={() =>
                                            this.toggleModal(
                                              "isOpenDeleteScanEmailModal",
                                              row.email_id,
                                              row.id
                                            )
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                }) : !scanEmailLoaging && <tr><td colSpan="8" className="text-center">No record Found</td></tr>}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Col>
        </Row>

        {/* Add Email Modal */}
        <Modal
          isOpen={openAddEmailModal}
          // centered={true}
          toggle={() => this.toggleModal("openAddEmailModal")}
        >
          <ModalHeader>{this.lang("Add Email")}</ModalHeader>
          <ModalBody className="mobile_user_card">
            <div className="form-group mobile_user_input">
              <label>{this.lang("Email Address")}</label>
              <input
                type="email"
                className="form-control"
                placeholder={this.lang("Email Address")}
                value={emailArr}
                onChange={(e) => this.handleModalInputChange(e, "emailArr")}
              />
              {emailArrError && (
                <div className="error" style={{ color: "red" }}>
                  {emailArrError}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={this.handleSubmit}
            >
              {this.lang("Save")}
            </Button>{" "}
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("openAddEmailModal")}
            >
              {this.lang("Cancel")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Add Scan Email Modal */}
        <Modal
          isOpen={openAddScanEmailModal}
          // centered={true}
          toggle={() => this.toggleModal("openAddScanEmailModal")}
        >
          <ModalHeader>{this.lang("Add Scan Email")}</ModalHeader>
          <ModalBody className="mobile_user_card">
            <div className="form-group mobile_user_input">
              <label>{this.lang("Email Address")}</label>
              <input
                type="email"
                className="form-control"
                placeholder={this.lang("Email Address")}
                value={scanEmailArr}
                onChange={(e) => this.handleModalInputChange(e, "scanEmailArr")}
              />
              {scanEmailArrError && (
                <div className="error" style={{ color: "red" }}>
                  {scanEmailArrError}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={this.handleScanEmailSubmit}
            >
              {this.lang("Save")}
            </Button>{" "}
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("openAddScanEmailModal")}
            >
              {this.lang("Cancel")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Edit Email Modal */}
        <Modal
          isOpen={isModalOpen}
          // centered={true}
          toggle={() => this.toggleModal("isModalOpen")}
        >
          <ModalHeader>{this.lang("Edit Email")}</ModalHeader>
          <ModalBody className="mobile_user_card">
            <div className="form-group mobile_user_input">
              <label>{this.lang("Email Address")}</label>
              <input
                type="email"
                className="form-control"
                value={selectedEmail}
                onChange={(e) =>
                  this.handleModalInputChange(e, "selectedEmail")
                }
              />
              {editEmailArrError && (
                <div className="error" style={{ color: "red" }}>
                  {editEmailArrError}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={this.handleModalSubmit}
            >
              {this.lang("Save")}
            </Button>{" "}
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("isModalOpen")}
            >
              {this.lang("Cancel")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Edit Scan Email Modal */}
        <Modal
          isOpen={isScanEmailModalOpen}
          // centered={true}
          toggle={() => this.toggleModal("isScanEmailModalOpen")}
        >
          <ModalHeader>{this.lang("Edit Scan Email")}</ModalHeader>
          <ModalBody className="mobile_user_card">
            <div className="form-group mobile_user_input">
              <label>{this.lang("Email Address")}</label>
              <input
                type="email"
                className="form-control"
                value={selectedEmail}
                onChange={(e) =>
                  this.handleModalInputChange(e, "selectedEmail")
                }
              />
              {editEmailArrError && (
                <div className="error" style={{ color: "red" }}>
                  {editEmailArrError}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={this.handleModalScanEmailSubmit}
            >
              {this.lang("Save")}
            </Button>{" "}
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("isScanEmailModalOpen")}
            >
              {this.lang("Cancel")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Delete Email Modal */}
        <Modal
          size="md"
          // centered={true}
          isOpen={this.state.isOpenDeleteEmailModal}
          className="dent_zero_modal"
          backdrop="static"
          toggle={() => this.toggleModal("isOpenDeleteEmailModal")}
        >
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image">
              <b>{this.lang("Delete Email Message")}</b>
            </p>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={() => {
                this.toggleModal("isOpenDeleteEmailModal");
                this.deleteEmail(this.state.emailAddressId);
              }}
            >
              {this.lang("Yes")}
            </Button>
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("isOpenDeleteEmailModal")}
            >
              {this.lang("No")}
            </Button>
          </ModalBody>
        </Modal>

        {/* Delete Scan Email Modal */}
        <Modal
          size="md"
          // centered={true}
          isOpen={this.state.isOpenDeleteScanEmailModal}
          className="dent_zero_modal"
          backdrop="static"
          toggle={() => this.toggleModal("isOpenDeleteScanEmailModal")}
        >
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image">
              <b>{this.lang("Delete Email Message")}</b>
            </p>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={() => {
                this.toggleModal("isOpenDeleteScanEmailModal");
                this.deleteScanEmail(this.state.emailAddressId);
              }}
            >
              {this.lang("Yes")}
            </Button>
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("isOpenDeleteScanEmailModal")}
            >
              {this.lang("No")}
            </Button>
          </ModalBody>
        </Modal>

        {/* Delete Name Modal */}
        <Modal
          size="md"
          // centered={true}
          isOpen={this.state.isOpenDeleteNameModal}
          className="dent_zero_modal"
          backdrop="static"
          toggle={() => this.toggleModal("isOpenDeleteNameModal")}
        >
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image">
              <b>{this.lang("Delete Name Message")}</b>
            </p>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={() => {
                this.toggleModal("isOpenDeleteNameModal");
                this.deleteName(this.state.authNameId);
              }}
            >
              {this.lang("Yes")}
            </Button>
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("isOpenDeleteNameModal")}
            >
              {this.lang("No")}
            </Button>
          </ModalBody>
        </Modal>

        {/* Add Authorize Name Modal */}
        <Modal
          isOpen={openAddNameModal}
          // centered={true}
          toggle={() => this.toggleModal("openAddNameModal")}
        >
          <ModalHeader>{this.lang("Add Name")}</ModalHeader>
          <ModalBody className="mobile_user_card">
            <div className="form-group mobile_user_input">
              <label>{this.lang("Authorize Name")}</label>
              <input
                type="email"
                className="form-control"
                value={authorizeName}
                placeholder={this.lang("Authorize Name")}
                onChange={(e) =>
                  this.handleModalInputChange(e, "authorizeName")
                }
              />
              {addNameError && (
                <div className="error" style={{ color: "red" }}>
                  {addNameError}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={this.handleAddAuthorizeName}
            >
              {this.lang("Save")}
            </Button>{" "}
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("openAddNameModal")}
            >
              {this.lang("Cancel")}
            </Button>
          </ModalFooter>
        </Modal>
        {/* Edit Name Modal */}
        <Modal
          // centered={true}
          isOpen={openEditNameModal}
          toggle={() => this.toggleModal("openEditNameModal")}
        >
          <ModalHeader>{this.lang("Edit Name")}</ModalHeader>
          <ModalBody className="mobile_user_card">
            <div className="form-group mobile_user_input">
              <label>{this.lang("Authorize Name")}</label>
              <input
                type="text"
                className="form-control"
                value={selectedName}
                placeholder={this.lang("Authorize Name")}
                onChange={(e) => this.handleModalInputChange(e, "selectedName")}
              />
              {editNameError && (
                <div className="error" style={{ color: "red" }}>
                  {editNameError}
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn btn-danger p-2 mr-2"
              onClick={this.handleEditNameModal}
            >
              {this.lang("Save")}
            </Button>{" "}
            <Button
              className="btn btn-cancel p-2"
              onClick={() => this.toggleModal("openEditNameModal")}
            >
              {this.lang("Cancel")}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default EmailAuthorized;
